let mietpreise_guests = document.querySelector("#mietpreise-guests");

if (mietpreise_guests) {
  mietpreise_guests.addEventListener("change", function (e) {
    this.form.submit();
  });
}
